<template>
  <div class="about-majority-career-position-wrapper my-large bg-white">
    <Head>
      <Title>{{ job.title }}</Title>
      <Meta name="description" hid="description" :content="$messages('about.career.meta_apply.description')" />
      <Meta name="robots" hid="robots" content="noindex, nofollow" />
    </Head>

    <AboutCareerJobPositionHeader :job-id="jobId" />
    <div class="container">
      <div class="flex flex-wrap -mx-tiny">
        <div class="block w-full px-standart">
          <hr>
        </div>
      </div>
      <div class="flex flex-wrap -mx-tiny">
        <div class="block w-full px-standart">
          <div id="grnhse_app" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { loadScript } from '@/utils/loadScript'
definePageMeta({
  key: route => route.query.gh_jid
})

const { $messages, $track } = useNuxtApp()
const route = useRoute()
let jobId = route.query.gh_jid
jobId = parseInt(jobId)

const jobApi = useJobs();
const job = await jobApi.getJobDetails(jobId)

if (!job) {
  throw error({ statusCode: 404 })
}
onMounted(() => {
  loadScript('https://boards.greenhouse.io/embed/job_board/js?for=rebtel').then(() => {
    if (window && window.Grnhse) {
      window.Grnhse.Iframe.load()
    }
  })
})

</script>
